import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL


export function getConnectors(SuscriptionId:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/connector')
  }

export function getInstancesWithAdd(SuscriptionId:number,source:string,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instanceswhithadd?source='+source,{params:{cloud,region}})
  }

export function getInstancesWithAddglobal(SuscriptionId:number,tenant:number,source:string,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instanceswhithadd?tenantId='+tenant+'&source='+source,{params:{cloud,region}})
  }


